import { useContext, useEffect, useState } from "react";
import { AppContext } from "@utils/AppContext";
import { useLocation, useNavigate } from "react-router-dom";
import { Table, Modal, Button, message, ConfigProvider } from "antd";
import GoBack from "../../../compoents/goBack/goBack";
import styles from './ImageServiceDetails.module.scss';
import api from "../../../../api/api";


//订单详情页
export default function ImageServiceDetails(props) {

    const { updateConfig } = useContext(AppContext);
    const location = useLocation();
    const navigate = useNavigate();
    const [orderDetails, setOrderDetails] = useState(null);
    const [TopDetails, setTopDetails] = useState(location.state);

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);
    const [frontPrice, setFrontPrice] = useState(0);
    const [endPrice, setEndPrice] = useState(0);

    useEffect(() => {
        updateConfig({ sidebarKey: 1 });
    }, []);

    const handleImageClick = (images) => {
        setSelectedImages(images);
        setIsModalVisible(true);
    };

    const handleModalClose = () => {
        setIsModalVisible(false);
        setSelectedImages([]);
    };

    const columns = [
        {
            title: '序列',
            dataIndex: 'idx',
            key: 'idx',
            align: 'center',
            width: 100,
            // render: (_, __, index) => index + 1,
        },
        {
            title: '源素材',
            dataIndex: 'skuImages',
            key: 'skuImages',
            align: 'center',
            width: 500,
            render: (skuImages) => (
                <div style={{ display: 'flex' }}>
                    {skuImages.slice(0, 3).map((image, i) => (
                        <img
                            key={i}
                            src={image}
                            alt={`SKU ${i}`}
                            className={styles.skuImage}
                            onClick={() => handleImageClick(skuImages)}
                        />
                    ))}
                    {skuImages.length > 3 && (
                        <div onClick={() => handleImageClick(skuImages)} style={{ width: '96px', height: '96px', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(245, 246, 252, 1)', fontSize: '10px', borderRadius: '12px', cursor: 'pointer' }}>
                            <div type="link" onClick={() => handleImageClick(skuImages)}>
                                等{skuImages.length - 3}张
                            </div>
                        </div>
                    )}
                </div>
            ),
        },
        {
            title: '底片数量',
            dataIndex: 'rawImageCount',
            key: 'rawImageCount',
            align: 'center',
            width: 152,
        },
        {
            title: '成片数量',
            dataIndex: 'finalImageCount',
            key: 'finalImageCount',
            align: 'center',
            width: 152,
        },
        {
            title: '备注',
            dataIndex: 'note',
            key: 'note',
            align: 'center',
        },
        // {
        //     title: '操作',
        //     key: 'action',
        //     align: 'center',
        //     render: () => <Button type="danger">删除</Button>,
        // },
    ];
    const [orderStatus, setOrderStatus] = useState();
    const orderId = TopDetails.orderId;//查询用id
    const fetchData = async (orderId) => {
        try {
            const response = await api.getOrderDetails({ orderId: orderId });
            const rawData = response.data;
            setOrderDetails(rawData.details); //订单详细需求
            setFrontPrice(rawData.frontPrice);
            setEndPrice(rawData.endPrice);
            setOrderStatus(rawData.status);
            console.log(rawData);
            // 更新TopDetails中相关的数据
            setTopDetails(prevDetails => ({
                ...prevDetails,
                totalPrice: rawData.totalPrice,//总价
                product: rawData.deliveryType,//交付物
                retouchTimes: rawData.refinedTimes,//精修次数
                deliveryDate: rawData.deliveryTime,//底片交付时间
                skuCount: rawData.skuCount,//需求数量
                retouchedCount: rawData.finishCount,//精修成片数
                deadline: rawData.endTime,//订单截止时间
                deliveredCount: rawData.baseImageCount,//底片总数
            }));
        } catch (error) {
            console.log(error);
        }
    }
    // console.log(TopDetails);
    useEffect(() => {
        fetchData(orderId);
    }, [orderId]);
    const data = Array.isArray(orderDetails)
        ? orderDetails.map((item, index) => ({
            key: index,
            skuImages: item.sku, 
            rawImageCount: item.baseImageCount,//交付底片数
            finalImageCount: item.finishCount,//成片图片数
            note: item.remark,
            idx:item.idx,//序列
        }))
        : [];
    console.log('data',data);
    const handleConfirm = async (status, id) => {
        try {
            const response = await api.confirmOrder({
                orderId: id,
                status: status,
            });
            console.log(response);
            if (response.code == 0) {
                if (status == 2) {
                    console.log('用户用户确认订单');
                    message.success('订单已确认');
                    fetchData(orderId);
                } else {
                    console.log('用户拒绝订单');
                    message.success('订单已拒绝');
                    fetchData(orderId);
                }
            } else {
                message.error(response.message);
                console.log(response.code, response.message);
            }
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <div className={styles.container}>
            <div className={styles.goback}><GoBack /></div>
            <div className={styles.describe}>基础信息</div>

            <div className={styles.group_container}>
                <div className={styles.group}>
                    <div className={styles.label}>交付物</div>
                    <div className={styles.value}>{TopDetails.product}</div>

                    <div className={styles.label}>精修次数</div>
                    <div className={styles.value}>{TopDetails.retouchTimes}</div>

                    <div className={styles.label}>底片交付日期</div>
                    <div className={styles.value}>{TopDetails.deliveryDate}</div>
                </div>

                <div className={styles.group}>
                    <div className={styles.label}>需求数量</div>
                    <div className={styles.value}>{TopDetails.skuCount}</div>

                    <div className={styles.label}>交付成片总数</div>
                    <div className={styles.value}>{TopDetails.retouchedCount}</div>

                    <div className={styles.label}>订单截止日期</div>
                    <div className={styles.value}>{TopDetails.deadline}</div>
                </div>

                <div className={styles.group}>
                    <div className={styles.label}>交付底片总数</div>
                    <div className={styles.value}>{TopDetails.deliveredCount}</div>
                    <div className={styles.label}></div><div className={styles.label}></div><div className={styles.label}></div><div className={styles.label}></div>
                </div>
            </div>
            <div style={{ border: '1px solid #EBF0FF', width: '98%', margin: 'auto' }}>{''}</div>
            <div className={styles.price_container}>
                <div className={styles.price_label}>总报价 &nbsp;&nbsp;&nbsp;</div>
                <div className={styles.price_value}>{TopDetails.totalPrice}</div>
                <div className={styles.price_details}>(定金{frontPrice}虹豆，尾款{endPrice}虹豆)</div>
            </div>

            <div className={styles.describe2}>详细需求</div>
            <ConfigProvider
                theme={{
                    token: {
                        headerSortActiveBg: '#F5F6FC',
                        // lineHeight:1.3,
                    }
                }}
            >
                <Table
                    className={styles.table}
                    columns={columns}
                    dataSource={data}
                    pagination={{ position: ['bottomCenter'], pageSize: 3, hideOnSinglePage: true }}
                    // scroll={{y:'3rem'}}
                />
            </ConfigProvider>
            {
                orderStatus == 1 ? //待确认状态
                    <div className={styles.button_container}>
                        <button className={styles.btn_refuse} onClick={() => handleConfirm(4, orderId)}>拒绝</button>
                        <button className={styles.btn_confirm} onClick={() => handleConfirm(2, orderId)}>确认</button>
                    </div>
                    :
                    <div></div>
            }
            <Modal
                open={isModalVisible}
                title="查看图片"
                footer={null}
                onCancel={handleModalClose}
                width={1300}
            >
                <div className={styles.modal_container}>
                    <div className={styles.modalImages}>
                        {selectedImages.map((image, index) => (
                            <img key={index} src={image} alt={`Image ${index}`} className={styles.modalImage} />
                        ))}
                    </div>
                    <div className={styles.modal_confirm_btn}>
                        <button className={styles.modalimg_btn} onClick={handleModalClose}>确定</button>
                    </div>
                </div>
            </Modal>
        </div>
    );
}
